import { render, staticRenderFns } from "./CommentHistoryCard.vue?vue&type=template&id=28e52d49&scoped=true"
import script from "./CommentHistoryCard.vue?vue&type=script&lang=ts"
export * from "./CommentHistoryCard.vue?vue&type=script&lang=ts"
import style0 from "./CommentHistoryCard.vue?vue&type=style&index=0&id=28e52d49&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e52d49",
  null
  
)

export default component.exports